import { floatingInputWpcf7 } from "../_components/_form";

window.$ = jQuery;

$( document ).ready( function () {

	floatingInputWpcf7();

	$(".js-position").each( function() {
        $(this).val($(this).closest(".container").find(".js-position-data").html());
	});
} );
